import { NgbTooltipModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { CmsConfig, ConfigModule, I18nModule, UrlModule } from '@spartacus/core';
import { FormErrorsModule, PageComponentModule, PageLayoutModule, PageSlotModule } from '@spartacus/storefront';

import { KnBrQuoteSearchComponent } from './kn-br-quote-search.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        UrlModule,
        I18nModule,
        FormErrorsModule,
        NgSelectModule,
        NgbTooltipModule,
        NgbModule,
        PageComponentModule,
        PageLayoutModule,
        PageSlotModule,
        ConfigModule.withConfig({
            cmsComponents: {
                KnBrQuoteSearchComponent: {
                    component: KnBrQuoteSearchComponent,
                },
            },
        } as CmsConfig),
        KnBrQuoteSearchComponent,
    ],
    exports: [KnBrQuoteSearchComponent],
})
export class KnBrQuoteSearchModule {}
